import script from "./ChecklistViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistViewPage.vue?vue&type=style&index=0&id=61806a54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61806a54"]])

export default __exports__